<template>
<div class="hp_election_widget">
    <div class="mast">
      <div class="title">RealClearPolitics Election 2020</div>
      <ul class="nav">
        <li @click="click_active_tab('president')" :class="{ active : active_tab == 'president' }">President</li>
        <li @click="click_active_tab('senate')" :class="{ active : active_tab == 'senate' }">Senate</li>
        <li @click="click_active_tab('house')" :class="{ active : active_tab == 'house' }">House</li>
      </ul><!-- .nav -->
    </div><!-- .mast -->
    <ul class="tabs">
      <li class="tab president" v-show="active_tab == 'president'">
        <table class="results">
          <tbody>
            <tr class="header">
              <td>Election 2020</td>
              <td>Biden</td>
              <td>Trump</td>
              <td>Results</td>
            </tr><!-- .header -->
            <tr v-if="!files['final_results']['loaded']"><td colspan="4"><div class="loading_row"></div></td></tr>
            <tr v-else>
              <td><a href="/epolls/2020/president/us/general_election_trump_vs_biden-6247.html">National Results</a></td>
              <td><a href="/epolls/2020/president/us/general_election_trump_vs_biden-6247.html" v-html="files['final_results']['data']['biden']"></a></td>
              <td><a href="/epolls/2020/president/us/general_election_trump_vs_biden-6247.html" v-html="files['final_results']['data']['trump']"></a></td>
              <td :class="files['final_results']['data']['spread_arrow']">
                <a href="/epolls/2020/president/us/general_election_trump_vs_biden-6247.html" :class="files['final_results']['data']['spread_aff']" v-html="files['final_results']['data']['spread']"></a>
                </td>
            </tr>
            <tr v-if="!files['top_bg']['loaded']"><td colspan="4"><div class="loading_row"></div></td></tr>
            <tr v-else>
              <td><a :href="files['top_bg']['url']">Top Battlegrounds</a></td>
              <td><a :href="files['top_bg']['url']">49.4</a></td>
              <td><a :href="files['top_bg']['url']">49.3</a></td>
              <td><a :href="files['top_bg']['url']" class="dem">Biden +0.1</a></td>
            </tr>
            <tr>
              <td><a href="/elections/live_results/2020/president/">Electoral College</a></td>
              <td><a href="/elections/live_results/2020/president/">306</a></td>
              <td><a href="/elections/live_results/2020/president/">232</a></td>
              <td class="tossups"><a href="/elections/live_results/2020/president/"></a></td>
            </tr>
          </tbody>
          <tbody>
            <tr class="header">
              <td>Top States</td>
              <td>Biden</td>
              <td>Trump</td>
              <td>Results</td>
            </tr><!-- .header -->
            <tr v-if="!files['battlegrounds_pres']['loaded']">
                <td colspan="4">
                    <div class="loading_row"></div>
                </td>
            </tr>
            <template v-else v-for="(state, s_index) in files['battlegrounds_pres']['data']['state_data']">
              <tr :key="s_index" >
                <td><a :href="state.url" v-html="state.name"></a></td>
                <td><a :href="state.url" v-html="state.biden"></a></td>
                <td><a :href="state.url" v-html="state.trump"></a></td>
                <td><a :href="state.url" v-html="state.spread" :class="state.spread_aff"></a></td>
              </tr>
            </template>
          </tbody>
        </table><!-- .results -->
        <div class="footer">
          <a href="/epolls/2020/president/2020_elections_electoral_college_map.html">Electoral Map</a> | 
          <a href="/epolls/2020/president/2020_elections_electoral_college_map_no_toss_ups.html">No Toss Ups</a> | 
          <a href="/epolls/2020/senate/2020_elections_senate_map.html">Senate Map</a> | 
          <a href="/epolls/latest_polls/elections/">Latest Polls</a>
        </div><!-- .footer -->
      </li><!-- .tab.president -->
      <li class="tab senate" v-show="active_tab == 'senate'">
        <ul class="top_boxes">
          <li>
            <div class="title"><a href="/elections/live_results/2020/senate/">Final Results</a></div>
            <ul class="scores" v-if="!files['senate_map_final']['loaded']">
              <li><div class="loading_row"></div></li>
            </ul>
            <ul class="scores" v-else>
              <li class="dem"><a href="/elections/live_results/2020/senate/" v-html="files['senate_map_final']['data']['dems']"></a></li>
              <li class="tossups"></li>
              <li class="gop"><a href="/elections/live_results/2020/senate/" v-html="files['senate_map_final']['data']['gop']"></a></li>
            </ul><!-- .scores -->
          </li>
          <li>
            <div class="title"><a href="">Georgia Runoffs</a></div>
                      <ul class="scores" v-if="!files['senate_ga_runoff_final']['loaded_ga1'] && !files['senate_ga_runoff_final']['loaded_ga2']">
                        <li><div class="loading_row"></div></li>
                      </ul>
                      <ul class="scores" v-else>
                      <li :class="files['senate_ga_runoff_final']['data']['ga1_aff']"><a :href="files['senate_ga_runoff_final']['data']['ga1_url']" v-html="files['senate_ga_runoff_final']['data']['ga1_spread_str']"></a></li>
                      <li :class="files['senate_ga_runoff_final']['data']['ga2_aff']"><a :href="files['senate_ga_runoff_final']['data']['ga2_url']" v-html="files['senate_ga_runoff_final']['data']['ga2_spread_str']"></a></li>
                      </ul><!-- .scores -->
          </li>
        </ul><!-- .top_boxes -->
        <table class="results">
          <tbody>
            <tr class="header">
              <td>State</td>
              <td>Results</td>
            </tr><!-- .header -->
            <tr v-if="!files['battlegrounds_senate']['loaded']"><td colspan="4">
                <div class="loading_row"></div></td>
            </tr>
            <template v-else v-for="(state, s_index) in files['battlegrounds_senate']['data']['state_data']">
              <tr>
                <td><a :href="state.url" v-html="state.name"></a></td>
                <td :class="state.spread_arrow"><a :href="state.url" :class="state.spread_aff" v-html="state.spread"></a></td>
              </tr>
            </template>
          </tbody>
        </table><!-- .results -->
        <div class="footer">
          <a href="/epolls/2020/senate/2020_elections_senate_map.html">RCP Senate Map</a> | 
          <a href="/epolls/2020/senate/2020_elections_senate_map_no_toss_ups.html">No Toss Up Map</a> | 
          <a href="/epolls/latest_polls/senate/">Latest Senate Polls</a>
        </div><!-- .footer -->
      </li><!-- .tab.senate -->
      <li class="tab house" v-show="active_tab == 'house'">
        <ul class="top_boxes">
          <li>
            <div class="title"><a href="/elections/live_results/2020/house/">Final Results</a></div>
            <ul class="scores" v-if="!files['house_map']['loaded']">
              <li><div class="loading_row"></div></li>
            </ul>
            <ul class="scores" v-else>
              <li class="dem"><a href="/elections/live_results/2020/house/" v-html="files['house_map']['data']['dems']"></a></li>
              <li class="tossups"><a href="/elections/live_results/2020/house/" v-html="files['house_map']['data']['tossups']"></a></li>
              <li class="gop"><a href="/elections/live_results/2020/house/" v-html="files['house_map']['data']['gop']"></a></li>
            </ul><!-- .scores -->
          </li>
          <li>
            <div class="title"><a href="/epolls/other/2020_generic_congressional_vote-6722.html">Generic Vote</a></div>
            <ul class="scores" v-if="!files['generic_ballot']['loaded']">
              <li><div class="loading_row"></div></li>
            </ul>
            <ul class="scores" v-else>
              <li class="full dem"><a href="/epolls/other/2020_generic_congressional_vote-6722.html">Democrats +2.4</a></li>
            </ul><!-- .scores -->
          </li>
        </ul><!-- .top_boxes -->
        <a class="map_image" href="/elections/live_results/2020/house/">
          <img src="/elections/live_results/2020/live_map_house_thumb.png" alt="House Map Final Results 2020">
        </a><!-- .map_image -->
        <table class="results">
          <tbody>
            <tr class="header">
              <td colspan="2" style="text-align: center;">Flipped Seats
                <ul v-if="files['battlegrounds_house']['loaded']" class="battlegrounds_switcher">
                  <template v-for="n in Math.ceil(files['battlegrounds_house']['data']['state_data'].length / per_page_house)">
                    <li @click="click_active_house(n)" :class="{ active : active_house == n }">
                        <img class="dot_1" :src="'/images/bg_battlegrounds_'+(active_house == n ? 'on' : 'off')+'.png'"></li>&nbsp;</template>
                </ul><!-- .battlegrounds_switcher -->
              </td>
            </tr><!-- .header -->
            <tr v-if="!files['battlegrounds_house']['loaded']">
                <td colspan="4">
                    <div class="loading_row"></div>
                </td>
            </tr>
            <template v-else v-for="(state, s_index) in files['battlegrounds_house']['data']['state_data']">
              <tr v-if="Math.ceil((s_index + 1) / per_page_house) == active_house" >
                <td><a :href="state.url" v-html="state.name"></a></td>
                <td :class="state.spread_arrow"><a :href="state.url" :class="state.spread_aff" v-html="state.spread"></a></td>
              </tr>
            </template>
          </tbody>
        </table><!-- .results -->
        <div class="footer">
          <a href="/epolls/2020/house/2020_elections_house_map.html">RCP House Map</a> | 
          <a href="/epolls/other/2020_generic_congressional_vote-6722.html">Generic Ballot</a> | 
          <a href="/epolls/latest_polls/house/">Latest House Polls</a>
        </div><!-- .footer -->
      </li><!-- .tab.house -->
    </ul><!-- .tabs -->
</div><!-- .hp_election_widget -->
</template>

<script>
export default {
    name: 'election-widget',
    data : function() {
    return {
      cache_bust : Math.floor((new Date()).getTime() / 25000), // Changes every 25 seconds
      active_tab : 'president', 
      active_tab_timer_list : [
        'president','president','president','president',
        'senate','senate',
        'house',
      ],
      active_tab_index : 0,
      active_tab_interval : 0,
      active_tab_seconds : 60,
      active_pres : 1,
      active_pres_interval : 0,
      active_pres_seconds : 45,
      per_page_pres : 6,
      active_house : 1,
      active_house_interval : 0,
      active_house_seconds : 30,
      per_page_house : 3,
      tab_timer_paused : false,
      files : {
        "final_results" : {
          "loaded" : false,
          "url" : "/epolls/2020/president/us/general_election_trump_vs_biden-6247.html",
          "title" : "Final Election Results 2020",
          "data_url" : "/elections/live_results/2020/homepage.json",
          "data" : {
            "biden" : 0,
            "trump" : 0,
            "spread" : "", 
            "spread_arrow" : "",
            "spread_aff" : "",
          },
        },
        "top_bg" : {
          "loaded" : false,
          "url" : "/elections/trump-vs-biden-top-battleground-states/",
          "title" : "Top Battlegrounds",
          "data_url" : "/json/battleground_script/key_battleground_states_2020_spread_average_long.json",
          "arrow_url" : "/widgets/2020_top_battleground_arrow.json",
          "data" : {
            "biden" : 0,
            "trump" : 0,
            "spread" : "", 
            "spread_arrow" : "",
            "spread_aff" : "",
          },
        },
        "latest_bo" : {
          "loaded" : false,
          "url" : "/elections/betting_odds/2020_president/",
          "title" : "Latest Betting Odds",
          "data_url" : "/json/odds/event_odds_1_final.json",
          "data" : {
            "biden" : 0,
            "trump" : 0,
            "spread" : "", 
          },
        },
        "electoral_map" : {
          "loaded" : false,
          "url" : "/epolls/2020/president/2020_elections_electoral_college_map.html",
          "title" : "RCP Electoral Map",
          "data_url" : "/poll/map/map_42.json",
          "data" : {
            "biden" : 0,
            "trump" : 0,
            "tossups" : "", 
          },
        },
        "electoral_map_ntu" : {
          "loaded" : false,
          "url" : "/epolls/2020/president/2020_elections_electoral_college_map_no_toss_ups.html",
          "title" : "No Toss Up States",
          "data_url" : "/poll/map/map_42_ntu.json",
          "data" : {
            "biden" : 0,
            "trump" : 0,
          },
        },
        "summary" : {
          "loaded" : false,
          "data_url" : "/json/battleground_script/summary.json",
          "data" : {
            "top_bg" : {
              "2020" : 0,
              "2016" : 0,
              "spread" : "",
              "url" : "/epolls/2020/president/us/trump-vs-biden-top-battleground-states-2020-vs-2016/",
            },
            "nat_avg" : {
              "2020" : 0,
              "2016" : 0,
              "spread" : "",
              "url" : "/epolls/2020/president/us/trump-vs-biden-national-polls-2020-vs-2016/",
            },
            "fav" : {
              "2020" : 0,
              "2016" : 0,
              "spread" : "",
              "url" : "/epolls/2020/president/us/trump-vs-biden-favorability-ratings-2020-vs-2016/",
            },
          },
        },
        "battlegrounds_pres" : {
          "loaded" : false,
          "data_url" : "/widgets/bgwidget_pres_2020_races.json",
          "data" : {
            "state_data" : [],
          }
        },
        "battlegrounds_senate" : {
          "loaded" : false,
          "data_url" : "/widgets/bgwidget_senate_2020_races.json",
          "data" : {
            "state_data" : [],            
          }
        },
        "battlegrounds_house" : {
          "loaded" : false,
          "data_url" : "/widgets/bgwidget_house_2020_races.json",
          "data" : {
            "state_data" : [],
          }
        },
        "senate_map" : {
          "loaded" : false,
          "url" : "/epolls/2020/senate/2020_elections_senate_map.html",
          "title" : "RCP Senate Map",
          "data_url" : "/poll/map/map_41.json",
          "data" : {
            "dems" : 0,
            "gop" : 0,
            "tossups" : "", 
          },
        },
        "senate_map_final" : {
          "loaded" : false,
          "url" : "/elections/live_results/2020/senate/",
          "title" : "Senate Final Results",
          "data_url" : "/elections/live_results/2020/homepage.json",
          "data" : {
            "dems" : 0,
            "gop" : 0,
          },
        },
        "senate_ga_runoff_final" : {
          "loaded" : false,
          "loaded_ga1" : false,
          "loaded_ga2" : false,
          "url" : "",
          "title" : "Georgia Runoffs",
          "data_url" : "",
          "data" : {
            "ga1_spread_str" : "",
            "ga2_spread_str" : "",
            "ga1_url": "",
            "ga2_url": "",
            "ga1_aff": "",
            "ga2_aff": ""
          },
        },
        "senate_map_bg" : {
          "loaded" : false,
          "url" : "/epolls/2020/senate/2020_elections_senate_map.html",
          "title" : "RCP Senate Map Battlegrounds",
          "data_url" : "/poll/map/map_41.json",
          "data" : {
            "state_data" : [],
          },
          "state_list" : ["mt","mn","me","sc","co","ks"],
        },
        "house_map" : {
          "loaded" : false,
          "url" : "/elections/live_results/2020/house/",
          "title" : "Final House Map 2020",
          "data_url" : "/elections/live_results/2020/house.json",
          "data" : {
            "dems" : 0,
            "gop" : 0,
            "tossups" : "", 
          },
        },
        "generic_ballot" : {
          "loaded" : false,
          "url" : "/epolls/other/2020_generic_congressional_vote-6722.html",
          "title" : "Generic Vote",
          "data_url" : "/poll/race/6722/historical_data.json",
          "data" : {
            "spread" : "",
          },
        },
      },
    };
  },

  mounted : function() {
    this.load_data();
    this.active_tab_init();
    this.active_pres_init();
  },

  methods : {

    click_active_house : function(num) {

      this.active_house = num;
      this.active_house_init();
      this.active_pres_init();
      this.active_tab_init();
    },

    active_house_init : function() {

      clearInterval(this.active_house_interval);
      this.active_house_interval = setInterval(function() {

        if(this.active_house == 4) {
          this.active_house = 1;
        } else {
          this.active_house++;
        }

      }.bind(this), 1000 * this.active_house_seconds);
    },

    click_active_pres : function(num) {

      this.active_pres = num;
      this.active_pres_init();
      this.active_house_init();
      this.active_tab_init();
    },

    active_pres_init : function() {

      clearInterval(this.active_pres_interval);
      this.active_pres_interval = setInterval(function() {

        if(this.active_pres == 1) {
          this.active_pres = 2;
        } else {
          this.active_pres = 1;
        }

      }.bind(this), 1000 * this.active_pres_seconds);
    },

    click_active_tab : function(str) {

      this.active_tab = str;
      this.active_tab_index = this.active_tab_timer_list.indexOf(str);

      clearInterval(this.active_tab_interval);
      this.tab_timer_paused = true;

      this.active_pres = 1;
      this.active_house = 1;

      this.active_house_init();
      this.active_pres_init();
    },

    active_tab_init : function() {

      if(this.tab_timer_paused) { return; }

      clearInterval(this.active_tab_interval);
      this.active_tab_interval = setInterval(function() {

        if(this.active_tab_index >= this.active_tab_timer_list.length - 1) {
          this.active_tab_index = 0;
        } else {
          this.active_tab_index++;
        }
        this.active_tab = this.active_tab_timer_list[this.active_tab_index];

      }.bind(this), 1000 * this.active_tab_seconds);
    },

    load_data : function() {

      axios.get(this.files['final_results']['data_url']+'?cache='+this.cache_bust)
      .then(function(response) {

        var total_votes = 0;
        var trump_votes = 0;
        var biden_votes = 0;
        for(let p=0; p < response['data']['president_summary']['candidates'].length; p++){
          var can = response['data']['president_summary']['candidates'][p];
          total_votes += parseInt(can.voteCount);
          if(can.last == "Trump") {
            trump_votes = parseInt(can.voteCount);
          } else if(can.last == "Biden") {
            biden_votes = parseInt(can.voteCount);
          }
        }
        
        this.files['final_results']['data']['biden'] = (biden_votes / total_votes * 100).toFixed(1);
        this.files['final_results']['data']['trump'] = (trump_votes / total_votes * 100).toFixed(1);

        this.files['final_results']['data']['spread'] = this.spread_from_values(['Biden', 'Trump'], [this.files['final_results']['data']['biden'], this.files['final_results']['data']['trump']]);
        this.files['final_results']['data']['spread_aff'] = this.spread_aff_from_values(['dem', 'gop'], [this.files['final_results']['data']['biden'], this.files['final_results']['data']['trump']]);

        this.files['final_results']['loaded'] = true;

      }.bind(this));

      axios.all([
        axios.get(this.files['top_bg']['data_url']+'?cache='+this.cache_bust),
        axios.get(this.files['top_bg']['arrow_url']+'?cache='+this.cache_bust),
      ])
      .then(function(response) {

        var r1 = response[0];

        this.files['top_bg']['data']['biden'] = this.v_one_dec(this.val_from_candidates(r1['data']['rcp_avg'][0]['candidate'], 'biden'));
        this.files['top_bg']['data']['trump'] = this.v_one_dec(this.val_from_candidates(r1['data']['rcp_avg'][0]['candidate'], 'trump'));
        this.files['top_bg']['data']['spread'] = this.spread_str_from_val(['Biden', 'Trump'], r1['data']['rcp_avg'][0]['spread']);
        this.files['top_bg']['data']['spread_aff'] = this.spread_aff_from_spread_val(['dem', 'gop'], r1['data']['rcp_avg'][0]['spread']);

        var prev_index = 1;
        r1['data']['rcp_avg'].some(function(avg, i) {
          if(avg['after_last_entered_avg'] == false) {
            prev_index = i + 1;
            return true;
          }
        });

        if(typeof r1['data']['rcp_avg'][prev_index] !== "undefined") {

          var biden_cur = this.val_from_candidates(r1['data']['rcp_avg'][prev_index-1]['candidate'], 'biden');
          var trump_cur = this.val_from_candidates(r1['data']['rcp_avg'][prev_index-1]['candidate'], 'trump');
          var biden_prev = this.val_from_candidates(r1['data']['rcp_avg'][prev_index]['candidate'], 'biden');
          var trump_prev = this.val_from_candidates(r1['data']['rcp_avg'][prev_index]['candidate'], 'trump');
          
          this.files['top_bg']['data']['spread_arrow'] = this.get_spread_arrow(
            ['dem', 'gop'], 
            [biden_cur, trump_cur],
            [biden_prev,trump_prev], 
            r1['data']['rcp_avg'][prev_index-1]['date'], 
            r1['data']['rcp_avg'][prev_index-1]['arrow_spread']
          );
        }

        if(response[1]['data']['override'] != 'default') {
          this.files['top_bg']['data']['spread_arrow'] = response[1]['data']['override'];
        }

        this.files['top_bg']['loaded'] = true;

      }.bind(this));

      axios.get(this.files['latest_bo']['data_url']+'?cache='+this.cache_bust)
      .then(function(response) {

        this.files['latest_bo']['data']['biden'] = this.v_one_dec(this.val_from_candidates(response['data']['rcp_event_odds'][0]['averages']['candidates'], 'joe biden'));
        this.files['latest_bo']['data']['trump'] = this.v_one_dec(this.val_from_candidates(response['data']['rcp_event_odds'][0]['averages']['candidates'], 'donald trump'));
        
        this.files['latest_bo']['loaded'] = true;

      }.bind(this));

      axios.get(this.files['electoral_map']['data_url']+'?cache='+this.cache_bust)
      .then(function(response) {

        this.files['electoral_map']['data']['biden'] = response['data']['election']['module_info']['total_dem'];
        this.files['electoral_map']['data']['trump'] = response['data']['election']['module_info']['total_gop'];
        this.files['electoral_map']['data']['tossups'] = response['data']['election']['module_info']['total_tu'];
        
        this.files['electoral_map']['loaded'] = true;

      }.bind(this));

      axios.get(this.files['electoral_map_ntu']['data_url']+'?cache='+this.cache_bust)
      .then(function(response) {

        this.files['electoral_map_ntu']['data']['biden'] = response['data']['election']['module_info']['total_dem'];
        this.files['electoral_map_ntu']['data']['trump'] = response['data']['election']['module_info']['total_gop'];
        
        this.files['electoral_map_ntu']['loaded'] = true;

      }.bind(this));

      // President Battleground States

      axios.all([
        axios.get(this.files['battlegrounds_pres']['data_url']+'?cache='+this.cache_bust),
        axios.get('/elections/live_results/2020/president.json?cache='+this.cache_bust),
      ]).then(function(response) {

        var axios_gets = [];

        var axios_gets = response[0].data.race_ids_pres_2020.map(function(item) {
          return axios.get('/poll/race/'+item+'/historical_data.json?cache='+this.cache_bust);
        }.bind(this));

        axios.all(axios_gets).then(function(response2) {

          response2.forEach(function(r1) {

            response[1]['data']['races'].forEach(function(r) {

              if(r.statePostal.toLowerCase() != r1['data']['state'].toLowerCase()) { return; }

              // Find Biden and Trump numbers
              var total_votes = 0;
              var trump_votes = 0;
              var biden_votes = 0;
              for(let p=0; p < r.reportingUnit['candidates'].length; p++){
                var can = r.reportingUnit['candidates'][p];
                total_votes += parseInt(can.voteCount);
                if(can.last == "Trump") {
                  trump_votes = parseInt(can.voteCount);
                } else if(can.last == "Biden") {
                  biden_votes = parseInt(can.voteCount);
                }
              }

              var spread_aff = "tie";

              if(trump_votes > biden_votes) {
                spread_aff = "gop";
              } else if(trump_votes < biden_votes) {
                spread_aff = "dem";
              }

              var new_data = {};

              //new_data['url'] = "/elections/live_results/2020/state/"+r.statePostal.toLowerCase()+"/president/";
              new_data['url'] = r1['data']['link'];
              new_data['name'] = r.stateName;
              new_data['biden'] = (biden_votes / total_votes * 100).toFixed(1);
              new_data['trump'] = (trump_votes / total_votes * 100).toFixed(1);
              new_data['spread'] = this.spread_from_values(['Biden', 'Trump'], [new_data['biden'], new_data['trump']]);
              new_data['spread_aff'] = spread_aff;

              this.files['battlegrounds_pres']['data']['state_data'].push(new_data);

            }.bind(this));
          }.bind(this));
        }.bind(this));

        this.files['battlegrounds_pres']['loaded'] = true;

      }.bind(this));

      // House Battleground States

      axios.all([
        axios.get(this.files['battlegrounds_house']['data_url']+'?cache='+this.cache_bust),
        axios.get('/elections/live_results/2020/house.json?cache='+this.cache_bust),
      ]).then(function(response) {

        var axios_gets = [];

        response[0].data.race_ids_house_2020.forEach(function(item) {
          axios_gets.push('/poll/race/'+item+'/polling_data.json?cache='+this.cache_bust);
        }.bind(this));

        axios.all(axios_gets.map(function(g) { return axios.get(g); })).then(function(response2) {

          var new_data = {};

          response2.forEach(function(r) {

            new_data = {};

            new_data['url'] = r['data']['moduleInfo']['link'];
            new_data['name'] = this.state_abbr_to_str(r['data']['moduleInfo']['state']);

            var district_num = r['data']['moduleInfo']['house_district'];
            var lookup_district = district_num;
            var district_str = "CD "+district_num;
            if(district_num == 0) {
              district_str = "At Large";
              lookup_district = 1;
            }
            new_data['name'] += ' '+district_str;

            // Get final election data for this state
            var final_r = response[1]['data']['races'].find(function(hr) {
              return hr.statePostal.toLowerCase() == r['data']['moduleInfo']['state'].toLowerCase()
              && hr.seatNum == lookup_district;
            }.bind(this));

            // Figure out spread from final election data
            var c_1 = { votes: 0, name: "temp", aff: "" };
            var c_2 = { votes: 0, name: "temp", aff: "" };
            var total_votes = 0;
            for(let p=0; p < final_r.reportingUnit['candidates'].length; p++){

              var can = final_r.reportingUnit['candidates'][p];

              total_votes += parseInt(can.voteCount);
              
              if(parseInt(can.voteCount) > c_1.votes) {
                c_2.votes = c_1.votes;
                c_2.name = c_1.last;
                c_2.aff = c_1.aff;
                c_1.votes = parseInt(can.voteCount);
                c_1.name = can.last;
                c_1.aff = can.party;
              } else if(parseInt(can.voteCount) > c_2.votes) {
                c_2.votes = parseInt(can.voteCount);
                c_2.name = can.last;
                c_2.aff = can.party;
              }
            }

            c_1.perc = (c_1.votes / total_votes * 100).toFixed(1);
            c_2.perc = (c_2.votes / total_votes * 100).toFixed(1);

            var spread_letter = "";
            if(c_1.aff.toLowerCase() == "dem") {
              spread_letter = " (D)";
            } else if(c_1.aff.toLowerCase() == "gop") {
              spread_letter = " (R)";
            }

            var spread = { 
              str: c_1.name+spread_letter+" +"+(c_1.perc - c_2.perc).toFixed(1), 
              aff: c_1.aff 
            };

            new_data['spread'] = spread.str;
            new_data['spread_aff'] = spread.aff.toLowerCase();

            this.files['battlegrounds_house']['data']['state_data'].push(new_data);

          }.bind(this));

          this.files['battlegrounds_house']['loaded'] = true;

        }.bind(this));

      }.bind(this));

      axios.get(this.files['senate_map']['data_url']+'?cache='+this.cache_bust)
      .then(function(response) {

        this.files['senate_map']['data']['dems'] = response['data']['election']['module_info']['total_dem']+' Dems';
        this.files['senate_map']['data']['gop'] = 'GOP '+response['data']['election']['module_info']['total_gop'];
        this.files['senate_map']['data']['tossups'] = response['data']['election']['module_info']['total_tu'];
        
        this.files['senate_map']['loaded'] = true;

      }.bind(this));

      axios.get(this.files['senate_map_final']['data_url']+'?cache='+this.cache_bust)
      .then(function(response) {

        this.files['senate_map_final']['data']['dems'] = response['data']['won_seats']['senate']['dem']+' Dems';
        this.files['senate_map_final']['data']['gop'] = 'GOP '+response['data']['won_seats']['senate']['gop'];
        this.files['senate_map_final']['data']['tossups'] = 100 - response['data']['won_seats']['senate']['dem'] - response['data']['won_seats']['senate']['gop'];
        
        this.files['senate_map_final']['loaded'] = true;

      }.bind(this));

      // Senate Battleground States

      axios.all([
        axios.get(this.files['battlegrounds_senate']['data_url']+'?cache='+this.cache_bust),
        axios.get('/elections/live_results/2020/senate.json?cache='+this.cache_bust),
      ]).then(function(response) {

        var axios_gets = [];

        var axios_gets = response[0].data.race_ids_senate_2020.map(function(item) {
          return axios.get('/poll/race/'+item+'/polling_data.json?cache='+this.cache_bust);
        }.bind(this));

        axios.all(axios_gets).then(function(response2) {

          response2.forEach(function(r1) {


            response[1]['data']['races'].forEach(function(r) {

              if(r.statePostal.toLowerCase() != r1['data']['moduleInfo']['state'].toLowerCase()) { return; }

              // Find spread
              var c_1 = { votes: 0, name: "temp", aff: "" };
              var c_2 = { votes: 0, name: "temp", aff: "" };
              var total_votes = 0;
              for(let p=0; p < r.reportingUnit['candidates'].length; p++){

                var can = r.reportingUnit['candidates'][p];

                total_votes += parseInt(can.voteCount);
                
                if(parseInt(can.voteCount) > c_1.votes) {
                  c_2.votes = c_1.votes;
                  c_2.name = c_1.last;
                  c_2.aff = c_1.aff;
                  c_1.votes = parseInt(can.voteCount);
                  c_1.name = can.last;
                  c_1.aff = can.party;
                } else if(parseInt(can.voteCount) > c_2.votes) {
                  c_2.votes = parseInt(can.voteCount);
                  c_2.name = can.last;
                  c_2.aff = can.party;
                }
              }

              c_1.perc = (c_1.votes / total_votes * 100).toFixed(1);
              c_2.perc = (c_2.votes / total_votes * 100).toFixed(1);

              var spread = { 
                str: c_1.name+" +"+(c_1.perc - c_2.perc).toFixed(1), 
                aff: c_1.aff,
                num: (c_1.perc - c_2.perc).toFixed(1)
              };

              


              var new_data = {};

              //new_data['url'] = "/elections/live_results/2020/state/"+r.statePostal.toLowerCase()+"/senate/";
              new_data['url'] = r1['data']['moduleInfo']['link'];
              new_data['name'] = r['stateName'];
              new_data['spread'] = spread.str;
              new_data['spread_aff'] = spread.aff.toLowerCase();                           


              //var new_ga_data = {};


              //special GA runoff
              //SEEMS THE GA SENATE FEEDS HAVE 2 SETS OF RACES INCLUDED IN THE JSON SET, SO WE HAD TO OMIT THE DUPLICATES
              if(new_data['url'].includes("7319") && c_1.name=="Warnock"){ //skip duplicate
                
              }else if(new_data['url'].includes("7318") && c_1.name=="Perdue"){ //skip duplicates

              }else{


                      //PARENT LOOP BRINGS IN FINAL-RESULTS DATA AND GA1/GA2 WE WANT TO DISPLAY RCP-AVERAGE DATA SO WE OVERRIDE BY TAPPING INTO R1.DATA SET 
                      if( new_data['url'].includes("7319") ){ 

                          console.log("georgiarunnoff");

                          new_data['name'] = new_data['name']+"";

                          var stateAverages = r1['data']['poll'];
                          //console.log(stateAverages);
                          stateAverages.forEach(function(averages){
                            console.log(averages);

                            if(averages['id']==7319 && averages['type']=="rcp_average"){
                                new_data['spread'] = averages['spread'].name +" "+ "+0.4";// averages['spread'].value;
                                new_data['spread_aff'] = this.aff_from_party(averages['spread'].affiliation.toLowerCase());

                                //new_ga_data['spread'] = new_data['name'] +": "+ new_data['spread_aff']+" "+ averages['spread'].value;
                                var party_initial = averages['spread'].affiliation.charAt(0).toUpperCase();
                                this.files['senate_ga_runoff_final']['data']['ga1_spread_str'] = "GA: " + party_initial +" "+ "+0.4";//averages['spread'].value;
                                this.files['senate_ga_runoff_final']['data']['ga1_url'] = new_data['url'];
                                this.files['senate_ga_runoff_final']['data']['ga1_aff'] = "dem"; //new_data['spread_aff']; 
                                this.files['senate_ga_runoff_final']['loaded_ga1'] = true;

                                // Make a request For GA Senate Runoff Election Data then override polls data with election data
                                axios.get('/json/ap_results/2021_runoff/live_results_jan_5th.json')
                                .then(function (response) {

                                  var data = response.data;
                                  data.forEach(function(d){
                                    if(d.id == "82325" && d.description == "Class II"){ //GA Perdue vs Ossoff //
                                        var candidate = d.candidates;

                                        var spread_ga = 0;
                                        var spread_ga_str = "";
                                        var dem_val = 0;
                                        var gop_val = 0;
                                        var dem_name = "";
                                        var gop_name = "";
                                        var winner_name = "";
                                        var aff_ga = "";
                                        var party_initial_ga = "";
                                        candidate.forEach(function(c){
                                          if(c.last == "Ossoff"){
                                            dem_val = c.vote_total_percent;
                                            dem_name = c.last;
                                          }
                                          if(c.last == "Perdue"){
                                            gop_val = c.vote_total_percent;
                                            gop_name = c.last;
                                          }
                                        }.bind(this));
                                        spread_ga = (dem_val - gop_val).toFixed(1);
                                        
                                        if(spread_ga > 0){
                                          aff_ga = "dem";
                                          spread_ga_str = "+" + spread_ga;
                                          winner_name = dem_name;
                                        }else if(spread_ga < 0){
                                          aff_ga = "gop";
                                          spread_ga_str = "-" + spread_ga;
                                          winner_name = gop_name;
                                        }
                                        
                                        party_initial_ga = aff_ga.charAt(0).toUpperCase();
                                        this.files['senate_ga_runoff_final']['data']['ga1_spread_str'] = "GA: " + party_initial_ga +" "+ spread_ga_str;
                                        this.files['senate_ga_runoff_final']['data']['ga1_url'] = "/elections/live_results/2020/senate/";
                                        this.files['senate_ga_runoff_final']['data']['ga1_aff'] = aff_ga; 
                                        new_data['spread'] = winner_name +" "+ spread_ga_str;
                                        //new_data['url'] = "/elections/live_results/2020/senate/";
                                        this.files['senate_ga_runoff_final']['loaded_ga1'] = true;

                                    }
                                  }.bind(this));
                                }.bind(this))
                                .catch(function (error) {
                                  // handle error
                                  console.log('get election data error')
                                  console.log(error);
                                })
                                .then(function () {
                                  // always executed
                                }); //End Axios Call to Get Ga Election Runoff data
                                
                            }

                          }.bind(this));



                      }else if( new_data['url'].includes("7318") ){

                          console.log("georgiarunnoff");                          

                          //PARENT LOOP BRINGS IN FINAL-RESULTS DATA AND GA1/GA2 WE WANT TO DISPLAY RCP-AVERAGE DATA SO WE OVERRIDE BY TAPPING INTO R1.DATA SET 
                          if( new_data['url'].includes("7318") ){ 

                              new_data['name'] = new_data['name']+"2";                                                        

                              var stateAverages = r1['data']['poll'];                              
                              stateAverages.forEach(function(averages){

                                if(averages['id']==7318 && averages['type']=="rcp_average"){
                                    new_data['spread'] = averages['spread'].name +" "+ "+1.2"; //averages['spread'].value;
                                    new_data['spread_aff'] = this.aff_from_party(averages['spread'].affiliation.toLowerCase());
                                    //new_ga_data['spread'] = new_data['name']+": "+ new_data['spread_aff']+" "+ averages['spread'].value;

                                    var party_initial = averages['spread'].affiliation.charAt(0).toUpperCase();
                                    
                                    if(averages['spread'].name.toLowerCase() == 'tie') {
                                      this.files['senate_ga_runoff_final']['data']['ga2_spread_str'] = "GA2: Tie";
                                    } else {
                                      this.files['senate_ga_runoff_final']['data']['ga2_spread_str'] = "GA2: " + party_initial +" "+ "+1.2"; //averages['spread'].value;
                                    }
                                    this.files['senate_ga_runoff_final']['data']['ga2_url'] = new_data['url'];
                                    this.files['senate_ga_runoff_final']['data']['ga2_aff'] = "dem";//new_data['spread_aff']; 
                                    this.files['senate_ga_runoff_final']['loaded_ga2'] = true;

                                    // Make a request For GA Senate Runoff Election Data then override polls data with election data
                                    axios.get('/json/ap_results/2021_runoff/live_results_jan_5th.json')
                                    .then(function (response) {
                                      // handle success
                                      //console.log('Election Data');
                                      //console.log(response);
                                      var data = response.data;
                                      data.forEach(function(d){
                                        if(d.id == "82324" && d.description == "Class III"){ //GA Perdue vs Ossoff //
                                            var candidate = d.candidates;

                                            var spread_ga = 0;
                                            var spread_ga_str = "";
                                            var dem_val = 0;
                                            var gop_val = 0;
                                            var dem_name = "";
                                            var gop_name = "";
                                            var winner_name = "";
                                            var aff_ga = "";
                                            var party_initial_ga = "";
                                            candidate.forEach(function(c){
                                              if(c.last == "Warnock"){
                                                dem_val = c.vote_total_percent;
                                                dem_name = c.last;
                                              }
                                              if(c.last == "Loeffler"){
                                                gop_val = c.vote_total_percent;
                                                gop_name = c.last;
                                              }
                                            }.bind(this));
                                            spread_ga = (dem_val - gop_val).toFixed(1);
                                            
                                            if(spread_ga > 0){
                                              aff_ga = "dem";
                                              spread_ga_str = "+" + spread_ga;
                                              winner_name = dem_name;
                                            }else if(spread_ga < 0){
                                              aff_ga = "gop";
                                              spread_ga_str = "-" + spread_ga;
                                              winner_name = gop_name;
                                            }
                                            //console.log("spread_ga_str " + spread_ga_str);
                                            party_initial_ga = aff_ga.charAt(0).toUpperCase();
                                            this.files['senate_ga_runoff_final']['data']['ga2_spread_str'] = "GA2: " + party_initial_ga +" "+ spread_ga_str;
                                            this.files['senate_ga_runoff_final']['data']['ga2_url'] = "/elections/live_results/2020/senate/";
                                            this.files['senate_ga_runoff_final']['data']['ga2_aff'] = aff_ga; 
                                            new_data['spread'] = winner_name +" "+ spread_ga_str;
                                            //new_data['url'] = "/elections/live_results/2020/senate/";
                                            this.files['senate_ga_runoff_final']['loaded_ga2'] = true;

                                        }
                                      }.bind(this));
                                    }.bind(this))
                                    .catch(function (error) {
                                      // handle error
                                      console.log('get election data error')
                                      console.log(error);
                                    })
                                    .then(function () {
                                      // always executed
                                    }); //End Axios Call to Get Ga Election Runoff data

                                    console.log('Data: ')
                                    console.log(this.files['senate_ga_runoff_final'])
                                }

                              }.bind(this));


                          }

                      }

                      this.files['battlegrounds_senate']['data']['state_data'].push(new_data);                        


              }

              
 

              
 



            }.bind(this));

          }.bind(this));
        }.bind(this));

        this.files['battlegrounds_senate']['loaded'] = true;

      }.bind(this));

      // Senate Battleground State from Map

      axios.get(this.files['senate_map_bg']['data_url']+'?cache='+this.cache_bust)
      .then(function(response) {

        var state_data = [];

        this.files['senate_map_bg']['state_list'].forEach(function(s) {

          response.data.election.race.forEach(function(r) {

            if(r.region_key.toLowerCase() == s) {
              state_data.push({
                url: r.url,
                name: r.name,
                status: this.status_filter(r.status),
                affiliation : this.status_to_aff(r.status),
              });
            }

          }.bind(this));

        }.bind(this));

        this.files['senate_map_bg']['data']['state_data'] = state_data;
        
        this.files['senate_map_bg']['loaded'] = true;

      }.bind(this));

      axios.get(this.files['house_map']['data_url']+'?cache='+this.cache_bust)
      .then(function(response) {

        this.files['house_map']['data']['dems'] = response['data']['won_seats']['house']['dem']+' Dems';
        this.files['house_map']['data']['gop'] = 'GOP '+response['data']['won_seats']['house']['gop'];
        this.files['house_map']['data']['tossups'] = 435 - response['data']['won_seats']['house']['gop'] - response['data']['won_seats']['house']['dem'];
        
        this.files['house_map']['loaded'] = true;

      }.bind(this));

      axios.get(this.files['generic_ballot']['data_url']+'?cache='+this.cache_bust)
      .then(function(response) {

        this.files['generic_ballot']['data']['democrats'] = this.v_one_dec(this.val_from_candidates(response['data']['rcp_avg'][0]['candidate'], 'democrats'));
        this.files['generic_ballot']['data']['republicans'] = this.v_one_dec(this.val_from_candidates(response['data']['rcp_avg'][0]['candidate'], 'republicans'));
        this.files['generic_ballot']['data']['spread'] = this.spread_from_values(['Democrats', 'Republicans'], [this.files['generic_ballot']['data']['democrats'], this.files['generic_ballot']['data']['republicans']]);
        this.files['generic_ballot']['data']['spread_aff'] = this.spread_aff_from_values(['dem', 'gop'], [this.files['generic_ballot']['data']['democrats'], this.files['generic_ballot']['data']['republicans']]);

        this.files['generic_ballot']['loaded'] = true;

      }.bind(this));

      axios.get(this.files['summary']['data_url']+'?cache='+this.cache_bust)
      .then(function(response) {

        this.files['summary']['data']['top_bg']['2020'] = response.data['top_bg']['2020'];
        this.files['summary']['data']['top_bg']['2016'] = response.data['top_bg']['2016'];
        this.files['summary']['data']['top_bg']['spread'] = response.data['top_bg']['diff'];
        this.files['summary']['data']['nat_avg']['2020'] = response.data['nat']['2020'];
        this.files['summary']['data']['nat_avg']['2016'] = response.data['nat']['2016'];
        this.files['summary']['data']['nat_avg']['spread'] = response.data['nat']['diff'];
        this.files['summary']['data']['fav']['2020'] = response.data['fav']['2020'];
        this.files['summary']['data']['fav']['2016'] = response.data['fav']['2016'];
        this.files['summary']['data']['fav']['spread'] = response.data['fav']['diff'];

        this.files['summary']['loaded'] = true;

      }.bind(this));
    },

    status_filter : function(str) {
      return str.replace('Leaning', 'Leans');
    },

    get_spread_arrow : function( aff_arr, current_arr, prev_arr, latest_date, arrow_override ) {

      // Determine arrow for spread

      var rcp_avg_date = new Date(latest_date);
      var today_date = new Date();
      var time_diff = Math.abs(today_date.getTime() - rcp_avg_date.getTime());
      var days_diff = Math.ceil(time_diff / (1000 * 3600 * 24));

      var spread_dir = "";
      var spread_aff = "";

      // If spread arrow overridden in CMS for an RCP Avg value, do so here
      if(typeof arrow_override !== 'undefined' && arrow_override != 0) {

        if(arrow_override == 1) {
          return "";
        } else if(arrow_override == 2) {
          spread_dir = "up";
        } else if(arrow_override == 3) {
          spread_dir = "down";
        }

        var spread_current = parseFloat(this.v_one_dec(parseFloat(current_arr[0]) - parseFloat(current_arr[1])));
        if(spread_current > 0 ) {
          spread_aff = aff_arr[0];
        } else {
          spread_aff = aff_arr[1];
        }

      } else if(days_diff <= 2 ) {

        var spread_current = parseFloat(this.v_one_dec(parseFloat(current_arr[0]) - parseFloat(current_arr[1])));
        var spread_prev = parseFloat(this.v_one_dec(parseFloat(prev_arr[0]) - parseFloat(prev_arr[1])));
        
        // determine direction by looking at previous spread and candidate

        if(spread_current == spread_prev) {

          return "";

        } else if(spread_current > spread_prev ) {

          if(spread_current < 0) {
            spread_dir = "down";
            spread_aff = aff_arr[1];
          } else {
            spread_dir = "up";
            spread_aff = aff_arr[0];
          }

        } else {
          
          if(spread_current > 0) {
            spread_dir = "down";
            spread_aff = aff_arr[0];
          } else {
            spread_dir = "up";
            spread_aff = aff_arr[1];
          }
        }
      } else {
        return "";
      }

      return 'arrow_'+spread_dir+'_'+spread_aff;
    },

    get_spread_arrow_from_spreads : function (spread_cur, spread_prev, aff_cur, aff_prev, latest_date, arrow_override) {

      var rcp_avg_date = new Date(latest_date);
      var today_date = new Date();
      var time_diff = Math.abs(today_date.getTime() - rcp_avg_date.getTime());
      var days_diff = Math.ceil(time_diff / (1000 * 3600 * 24));
     
      var spread_dir = "";
      var spread_aff = "";

      if(spread_cur == spread_prev) {
        return "";
      }
      if(spread_cur == 'Tie') {
        if(aff_prev == 'dem') {
          spread_aff = "dem";
          spread_dir = "down"
        } else if(aff_prev == 'gop') {
          spread_aff = "gop";
          spread_dir = "down"
        }
      } else {

        // If spread arrow overridden in CMS for an RCP Avg value, do so here
        if(typeof arrow_override !== 'undefined' && arrow_override != 0) {
          
          if(arrow_override == 1) {
            return "";
          } else if(arrow_override == 2) {
            spread_dir = "up";
          } else if(arrow_override == 3) {
            spread_dir = "down";
          }

          spread_aff = aff_cur;

        } else if(days_diff <= 2 ) {

          var spread_cur_score = parseFloat(spread_cur.split(' +')[1]);
          var spread_prev_score = parseFloat(spread_prev.split(' +')[1]);
          if(spread_cur_score == spread_prev_score) {

            return "";

          } else if(aff_cur != aff_prev) {

            spread_dir = "up";
            spread_aff = aff_cur;

          } else if(spread_cur_score > spread_prev_score ) {

            if(spread_cur_score < 0) {
              spread_dir = "down";
              spread_aff = aff_prev;
            } else {
              spread_dir = "up";
              spread_aff = aff_cur;
            }

          } else {
            
            if(spread_cur_score > 0) {
              spread_dir = "down";
              spread_aff = aff_cur;
            } else {
              spread_dir = "up";
              spread_aff = aff_prev;
            }
          }

        } else {
          return "";
        }
      }
      return 'arrow_'+spread_dir+'_'+spread_aff;
    },

    status_to_aff : function(status) {

      if(status.toLowerCase().includes('gop')) {
        return 'gop';
      } else if(status.toLowerCase().includes('dem')) {
        return 'dem';
      } else {
        return 'tie';
      }
    },

    val_from_candidates : function(candidates, c_name) {

      var c_val = 0;

      candidates.forEach(function(c) {

        if(c['name'].toLowerCase() == c_name) {
          c_val = c['value'];
        }

      }.bind(this));

      return c_val;
    },

    spread_from_values : function( c_arr, v_arr, no_dec ) {

      if(typeof no_dec === 'undefined') {
        no_dec = false;
      }

      var v1 = parseFloat(v_arr[0]);
      var v2 = parseFloat(v_arr[1]);
      var spread_val = v1 - v2;
      var spread_val_str = spread_val;
      if(!no_dec) {
        spread_val_str = this.v_one_dec(Math.abs(spread_val));
      }

      if(spread_val > 0) {
        return c_arr[0]+' +'+spread_val_str;
      } else if(spread_val < 0) {
        return c_arr[1]+' +'+spread_val_str;
      } else {
        return 'Tie';
      }
    },

    spread_from_candidates : function( c_arr ) {
      var first_c_index = 0;
      var second_c_index = 0;
      var first_c_score = 0;
      var second_c_score = 0;
      c_arr.forEach(function(c, i) {
        var v = parseFloat(c.value);
        if(v >= first_c_score) {
          second_c_score = first_c_score;
          first_c_score = v;
          second_c_index = first_c_index;
          first_c_index = i;
        } else if(v >= second_c_score) {
          second_c_score = v;
          second_c_index = i;
        }
      }.bind(this));

      if(first_c_score > second_c_score) {
        var spread_val = first_c_score - second_c_score;
        return c_arr[first_c_index].name+' ('+c_arr[first_c_index].affiliation.charAt(0)+') +'+this.v_one_dec(spread_val);
      } else {
        return 'Toss Up';
      }
    },

    spread_aff_from_candidates : function( c_arr ) {

      var first_c_index = 0;
      var second_c_index = 0;
      var first_c_score = 0;
      var second_c_score = 0;
      c_arr.forEach(function(c, i) {
        var v = parseFloat(c.value);
        if(v >= first_c_score) {
          second_c_score = first_c_score;
          first_c_score = v;
          second_c_index = first_c_index;
          first_c_index = i;
        } else if(v >= second_c_score) {
          second_c_score = v;
          second_c_index = i;
        }
      }.bind(this));

      if(first_c_score > second_c_score) {
        return this.aff_from_party(c_arr[first_c_index].affiliation);
      } else {
        return '';
      }
    },

    aff_from_party : function( party ) {

      if(party.toLowerCase() == 'republican') {
        return 'gop';
      } else if(party.toLowerCase() == 'democrat') {
        return 'dem';
      } else {
        return 'tie';
      }
    },

    spread_aff_from_values : function( aff_arr, v_arr ) {

      var v1 = parseFloat(v_arr[0]);
      var v2 = parseFloat(v_arr[1]);

      if(v1 > v2) {
        return aff_arr[0];
      } else if(v1 > v2) {
        return aff_arr[1];
      } else {
        return '';
      }
    },

    spread_str_from_val : function(c_arr, s_val) {

      if(parseFloat(s_val) > 0) {
        return c_arr[0]+' +'+this.v_one_dec(s_val);
      } else if(parseFloat(s_val) < 0) {
        return c_arr[1]+' +'+this.v_one_dec(Math.abs(s_val));
      } else {
        return 'Tie';
      }
    },

    spread_aff_from_spread_val : function( aff_arr, s_val ) {

      if(parseFloat(s_val) > 0) {
        return aff_arr[0];
      } else if(parseFloat(s_val) < 0) {
        return aff_arr[1];
      } else {
        return '';
      }
    },

    v_one_dec: function (value) {
        var the_value = parseFloat(value);
        return the_value.toFixed(1);
    },

    state_abbr_to_str : function(abbr) {

      abbr = abbr.toUpperCase();
      var states = {
        'AL' : 'Alabama',
        'AK' : 'Alaska',
        'AZ' : 'Arizona',
        'AR' : 'Arkansas',
        'CA' : 'California',
        'CO' : 'Colorado',
        'CT' : 'Connecticut',
        'DC' : 'District of Columbia',
        'DE' : 'Delaware',
        'FL' : 'Florida',
        'GA' : 'Georgia',
        'HI' : 'Hawaii',
        'ID' : 'Idaho',
        'IL' : 'Illinois',
        'IN' : 'Indiana',
        'IA' : 'Iowa',
        'KS' : 'Kansas',
        'KY' : 'Kentucky',
        'LA' : 'Louisiana',
        'ME' : 'Maine',
        'MECD2' : 'Maine CD2',
        'MD' : 'Maryland',
        'MA' : 'Massachusetts',
        'MI' : 'Michigan',
        'MN' : 'Minnesota',
        'MS' : 'Mississippi',
        'MO' : 'Missouri',
        'MT' : 'Montana',
        'NE' : 'Nebraska',
        'NV' : 'Nevada',
        'NH' : 'New Hampshire',
        'NJ' : 'New Jersey',
        'NM' : 'New Mexico',
        'NY' : 'New York',
        'NC' : 'North Carolina',
        'ND' : 'North Dakota',
        'OH' : 'Ohio',
        'OK' : 'Oklahoma',
        'OR' : 'Oregon',
        'PA' : 'Pennsylvania',
        'RI' : 'Rhode Island',
        'SC' : 'South Carolina',
        'SD' : 'South Dakota',
        'TN' : 'Tennessee',
        'TX' : 'Texas',
        'US' : 'National',
        'UT' : 'Utah',
        'VT' : 'Vermont',
        'VA' : 'Virginia',
        'WA' : 'Washington',
        'WV' : 'West Virginia',
        'WI' : 'Wisconsin',
        'WY' : 'Wyoming',
      };

      if(typeof states[abbr] !== 'undefined') {
        return states[abbr];
      } else {
        return '';
      }

    },

  },
}
</script>

<style>
@import "../../../../vertical/rcp/2020_election/post_election_widget.css";
</style>